/**
 * Used to wrap another error so that its stack trace can be used, but provide context for why
 * it is being re-thrown.
 */
export class WrappedError extends Error {
  constructor (message: string, error: Error) {
    super(message);
    this.stack = this.stack + `\n\nWrapped Error:\n\t` + error.stack?.replaceAll('\n', '\n\t');
  }
}